module.exports = __webpack_public_path__ + "static/media/aw_desktop_hero_350_mozza_en.577fdd8e.jpg";